export default __webpack_public_path__ + "static/media/step5.eb7a119d.jpg";